import { adCodeStrings } from 'constants/strings'
import type { TAdCodeConfidence } from 'types'
import { cn } from '../../utils/cn'

type Props = {
  name: string
  confidence: TAdCodeConfidence
  className?: string
}

/**
 * 友だち一覧・詳細で流入元を示すバッジ。
 *
 * 確定と推定を色だけで区別すると判別できない環境があるため、
 * 塗り／輪郭の違いに加えて読み上げ用のテキストにも確度を入れる。
 */
export function AdCodeBadge({ name, confidence, className }: Props) {
  const isConfirmed = confidence === 'HIGH'
  const label = adCodeStrings.confidence[confidence]

  return (
    <span
      className={cn('inline-flex items-center gap-1.5 text-xs', className)}
      title={`${name}（${label}）`}
    >
      <span
        aria-hidden="true"
        className={cn(
          'inline-block h-2 w-2 shrink-0 rounded-full',
          isConfirmed ? 'bg-accent' : 'border-2 border-amber-600',
        )}
      />
      <span className="text-ink">{name}</span>
      <span className="sr-only">{label}</span>
    </span>
  )
}
